import * as React from 'react'
import { withRouter } from 'react-router-dom';
import { useState } from 'react';

import SecondaryMenu from '../shared/SecondaryMenu'
import { IAppPropsWithRoute } from '../../common/types';
import api from '../../store/api';
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Table from '@material-ui/core/Table';
import LinearProgress from '@material-ui/core/LinearProgress';
import throttle from 'lodash/throttle';
import eventNames from '../../store/signalr/eventNames';
import { addTaskForEvent, removeTaskForEvent } from '../../store/signalr/tasksForEvents';

const useStyles = makeStyles((theme) => ({
    root: {
        //   padding: theme.spacing(0, 0, 0, 35),
        paddingLeft: 40,
        paddingRight: 40,
    },
    heading: {
        fontSize: 36,
        padding: theme.spacing(5, 0, 5, 0),
        fontWeight: 900,
    },
    gridStyle: {
        padding: theme.spacing(5, 0, 5, 0)
    },
    searchTextBox: {
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: 0,
            top: 4
        },
        height: 44,
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '44px',
        border: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    searchBtn: {
        fontWeight: 'bold',
    },
    table: {
        tableLayout: 'fixed'
    },
    tableRow: {
        cursor: 'pointer'
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2, 0, 0, 50),
        },
    },
}));

interface LocationsWidgetProps extends IAppPropsWithRoute {

};

interface Location {
    locationId: string,
    name: string
    shortName: string,
    customerName: string,
    typeName: string,
    deleted: boolean
};

const headCells = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Name', width:'20%' },
    { id: 'shortName', numeric: false, disablePadding: false, label: 'Shortname',width:'20%' },
    { id: 'customerName', numeric: false, disablePadding: false, label: 'Customer',width:'20%' },
    { id: 'typeName', numeric: false, disablePadding: false, label: 'Type',width:'20%' },
];

const componentTaskId = "locationsWidget";

function LocationsWidget(props: LocationsWidgetProps): JSX.Element {
    const classes = useStyles();
    const [dense, setDense] = React.useState(false);
    const [orderBy, setOrderBy] = React.useState('name');
    const [order, setOrder] = React.useState('asc');
    const [page, setPage] = React.useState(0);
    const [searchText, setSearchText] = React.useState('');
    const [recordCount, setRecordCount] = React.useState(0);
    const [locationList, setLocationList] = React.useState<Location[]>([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [selected, setSelected] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const history = useHistory();
    const refOrder = React.useRef('asc');
    const refOrderBy = React.useRef('userCombinedName');
    const refSearchText = React.useRef('');
    const refPage = React.useRef(0);

    const whenRefreshLocationsDo = () => getAllLocations(refPage.current, refSearchText.current, refOrder.current, refOrderBy.current);

    React.useEffect(() => {
        getAllLocations(0, '', 'asc', 'name');
    }, []);


    React.useEffect(() => {
        addTaskForEvent(eventNames.refreshLocations, componentTaskId, whenRefreshLocationsDo);
        return () => {
            removeTaskForEvent(eventNames.refreshLocations, componentTaskId);
        }
    }, [whenRefreshLocationsDo]);

    React.useEffect(() => {
        refPage.current = page;
        refSearchText.current = searchText;
        refOrder.current = order;
        refOrderBy.current = orderBy;
    }, [page, searchText, order, orderBy]);

    const getAllLocations = React.useMemo(() => throttle(async (updatePageNumber: any, keyword: string, sortOrder: any, sortColumn: any): Promise<void> => {
        setLoading(true);
        const _res = await api.GetAndSearchLocations('searchstr=' + keyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + '&pagesize=10&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder);
        if (_res !== null && _res.data !== null && _res.data.model !== null) {
            setRecordCount(_res.data.itemsCount);
            if (_res.data.itemsCount > 0 && updatePageNumber >= page) {
                setLocationList(_res.data.model);
            } else if (_res.data.itemsCount > 0 && (page == 0 || page == 1)) {
                setLocationList(_res.data.model);
            } else if (_res.data.itemsCount === 0) {
                setLocationList([]);
            }
        } else {
            setLocationList([]);
        }
        setLoading(false);
    }, 200), []);

    const createSortHandler = (event: any, column: any) => {
        var order_str = (orderBy == column ? (order === 'asc' ? 'desc' : 'asc') : 'asc');
        setOrder(order_str);
        setOrderBy(column);
        getAllLocations(page, searchText, order_str, column);
    }

    const search = async (keyword: string): Promise<void> => {
        setPage(0);
        getAllLocations(0, keyword, order, orderBy);
    }

    const searchByEnter = async (event: any): Promise<void> => {
        if (event.key === 'Enter') {
            await search(searchText);
        }
    }

    const inputChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
        search(e.target.value);
    }

    const handleChangePage = (event: any, newPage: any) => {
        const updatePage = newPage + 1;
        setPage(newPage);
        getAllLocations(updatePage, searchText, order, orderBy);
    };

    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
            <div className={classes.loading}>
                <LinearProgress color="primary" />
            </div>
        )
    }

    const addLocationClick = (event: any) => {
        history.push({
            pathname: '/settings/locations/add'
        });
    };

    const editLocationClick = (event: any, id: any) => {
        if (id) {
            setSelected(id);
            history.push({
                pathname: '/settings/locations/edit/' + id,
            });
        }
    };


    return (
        <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>

            <div style={{ alignSelf: 'stretch', display: 'flex' }}>
                <SecondaryMenu selectedmenu='Locations' />
            </div>

            <div style={{ display: 'flex', alignSelf: 'start' }}>
                <Grid container style={loading ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                    <Grid item xs={6} style={{ paddingLeft: 40 }}>
                        <div className={classes.heading}>Locations</div>
                    </Grid>
                    <Grid item container xs={6} justify="flex-end" style={{ paddingRight: 25, paddingTop: 40, paddingBottom: 40 }}>
                        
                        <div style={{display: 'flex',}}>
                            <TextField
                                classes={{ root: classes.searchTextBox }}
                                InputProps={{

                                    startAdornment: < InputAdornment position="end" >
                                            <SearchIcon style={{ color: "#707070" }} />
                                    </InputAdornment>
                                }}
                                variant='outlined'
                                className="searchTxt"
                                id="standard-adornment-password"
                                type="text"
                                onKeyPress={searchByEnter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => inputChangedHandler(e)}
                            />

                            <Button className="searchBtn" style={{ marginLeft: 20 }} variant="contained" color="primary" onClick={addLocationClick}>Add Location</Button>
                           
                            </div>
                    </Grid>
                  


                    <Grid container item xs={12} justify="flex-end">

                        <TableContainer>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                aria-label="enhanced table"
                                size={dense ? 'small' : 'medium'}>

                                <TableHead>
                                    <TableRow>
                                        {headCells.map((headCell) => (
                                            <TableCell
                                                key={headCell.id}
                                                align={headCell.numeric ? 'right' : 'left'}
                                                width={headCell.width}
                                                sortDirection={orderBy === headCell.id ? 'asc' : false}>
                                                <TableSortLabel
                                                    active={orderBy === headCell.id}
                                                    direction={orderBy === headCell.id ? (order === 'asc' ? 'asc' : 'desc') : undefined}
                                                    onClick={(e => createSortHandler(e, headCell.id))}>
                                                    {headCell.label}
                                                </TableSortLabel>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {locationList.length > 0 ?
                                        locationList.map((row, index) => {
                                            return (
                                                <TableRow
                                                    className={classes.tableRow}
                                                    hover
                                                    onClick={(event) => editLocationClick(event, row.locationId)}
                                                    tabIndex={-1}
                                                    key={row.locationId}
                                                    role="checkbox">
                                                    <TableCell align="left">{row.name}</TableCell>
                                                    <TableCell align="left">{row.shortName}</TableCell>
                                                    <TableCell align="left">{row.customerName}</TableCell>
                                                    <TableCell align="left">{row.typeName}</TableCell>
                                                </TableRow>
                                            );
                                        })
                                        :
                                        <TableRow>
                                            <TableCell align="center" colSpan={5}>No data available</TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={recordCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                        />
                    </Grid>
                </Grid>
                <div style={{ marginTop: 5, marginBottom: 20 }}>
                    {loading ? <CreateLoadingLine /> : null}
                </div>
            </div>
          
        </div>
    );
}

export default React.memo(withRouter(LocationsWidget));